<template>
	<div class="xybg-main">
		<div class="xybg-title">
			<div class="">信用报告查询</div>
		</div>
		<div class="xybg-input">
			<van-field v-model="shxydm" error placeholder="请输入社会信用代码" />
		</div>
		<div class="xybg-btn">
			<div class="xybg-cxbtn" @click="submit_xybgcx">查询</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				shxydm: '',
			}
		},
		methods: {
			submit_xybgcx() {
				
				let shxydm = this.shxydm;
				if (!shxydm) {
					Toast.fail('请输入社会信用代码');
				} else {
					this.$router.push({
						path: 'XybgIndex',
						query: {
							'shxydm': shxydm
						}
					})
				}
			},
		}
	}
</script>

<style>
	body {
		background-color: white;
		
	}

	.xybg-main {
		background-color: white;
		font-size: 18px;
		margin: 24px;
	}

	.xybg-title {
		font-weight: 700;
		margin: 10px 0;
	}

	.xybg-input {
		margin: 10px 0;
	}

	.van-cell {
		padding: 0;
	}

	.xybg-input input {
		height: 30px;
		width: 100%;
		border-radius: 10px;
		background: #f9f9f9;
		text-indent: 10px;
	}

	.xybg-btn {
		margin: 10px 0;
	}

	.xybg-cxbtn {
		background-color: #0076E9;
		border-radius: 10px;
		color: white;
		font-size: 14px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		cursor: pointer;
	}
</style>
